import AttemptsService from "@/services/AttemptsService";

export default {
    state() {
        return {
            attempts: [],
            attempt: {},
        }
    },

    getters: {
        getAttempts: (state) => state.attempts,
        getAttempt: (state) => state.attempt,
    },

    mutations: {
        setAttempts(state, data) {
            state.attempts = data;
        },
        setAttempt(state, data) {
            state.attempt = data;
        },
        resetAttempt(state) {
            state.attempt = {};
        },
    },

    actions: {
        setAttemptData({commit}, payload) {
          commit('setAttempt', payload)
        },

        async findAttempt({ commit }, payload) {
            try {
                const response = await AttemptsService.findAttempt(payload.data, payload.userToken);

                commit('setAttempt', response.data);
            } catch (error) {
                console.error('Erro ao buscar tentativa', error);

                throw error;
            }
        },

        async startAttempt({ commit }, payload) {
            try {
                const response = await AttemptsService.startAttempt(payload.data, payload.userToken);
                commit('setAttempt', response);

                return response;
            } catch (error) {
                console.error('Erro ao iniciar tentativa', error);

                throw error;
            }
        },

        async finishAttempt({ commit, dispatch }, payload) {
            try {
                dispatch('setLoadingState', { loadignState: true, loadingView: 'AttemptsCard'  })
                const response = await AttemptsService.finishAttempt(payload.data, payload.userToken);
                !payload.data.materialIsChecked && (await dispatch('changeMaterialItemStatus', {
                    requestData: {
                        materialItemId: payload.data.materialItemId,
                        check: true,
                        ...payload?.data?.user_id && { user_id: payload.data.user_id }
                    },
                    userToken: payload.userToken
                }))

                const actualDate = new Date()
                const ano = actualDate.getFullYear();
                const mes = String(actualDate.getMonth() + 1).padStart(2, '0');
                const dia = String(actualDate.getDate()).padStart(2, '0');
                const horas = String(actualDate.getHours()).padStart(2, '0');
                const minutos = String(actualDate.getMinutes()).padStart(2, '0');
                const segundos = String(actualDate.getSeconds()).padStart(2, '0');

                dispatch('updateAttemptFinishedAt', { attemptId: payload.data.attemptId, finished_at: `${ano}-${mes}-${dia} ${horas}:${minutos}:${segundos}` })
                commit('setAttempt', response.data);
            } catch (error) {
                dispatch('toastfy/activeErrorNotification', { text: `Ocorreu um erro ao finalizar a tentativa! Tente novamente` })
            } finally {
                dispatch('setLoadingState', { loadignState: false })
            }
        },

        async checkAttempt({ commit }, payload) {
            try {
                const response = await AttemptsService.checkAttempt(payload.data, payload.userToken);

                commit('setAttempt', response.data);
            } catch (error) {
                console.error('Erro ao verificar tentativa', error);

                throw error;
            }
        },

        async answerAttempt({ commit }, payload) {
            try {
                const response = await AttemptsService.answerAttempt(payload.data, payload.userToken);

                commit('setAttempt', response.data);
            } catch (error) {
                console.error('Erro ao responder tentativa', error);

                throw error;
            }
        },

        async deleteAttempt({ commit, dispatch }, payload) {
            try {
                dispatch('setLoadingState', { loadignState: true, loadingView: 'AttemptsCard'  })
                await AttemptsService.deleteAttempt(payload.data, payload.userToken);
                dispatch('deleteMaterialItemAnswer', payload.data.attemptId)
                dispatch('toastfy/activeSuccesNotification', { text: "Tentativa Excluida com Sucesso!" })
                commit('resetAttempt');
            } catch (error) {
                dispatch('toastfy/activeErrorNotification', { text: 'Ocorreu um erro ao excluir tentativa! Tente novamente' })
            } finally {
                dispatch('setLoadingState', { loadignState: false })
            }
        }
    }
}